/* 配储方案相关接口 */
import http from "./request";

// 获取最新电价
export function getLatestEelectricPrice(id) {
	return http(`/project/latestElecPrice/${id}`, {
		method: "GET",
		params: {},
	});
}

// 开始配储评估
export function startEsAnalysis(params) {
	return http("/project/esAnalysis", {
		method: "POST",
		params: params,
	});
}

// 获取分析进度
export function getScheduleData(id) {
	return http(`/project/esAnalysisProcess/${id}`, {
		method: "GET",
		params: {},
	});
}

// 获取分析结果
export function getAnalysisResult(id) {
	return http(`/project/esAnalysisResult/${id}`, {
		method: "GET",
		params: {},
	});
}

// 获取分套容量列表
export function getCapacityList(id) {
	return http(`/project/esAnalysisCapacityList/${id}`, {
		method: "GET",
		params: {},
	});
}

// 查询分套结果详情
export function getCapacityDetail(jobId) {
	return http(`/project/esAnalysisTypicalInfo/${jobId}`, {
		method: "GET",
		params: {},
	});
}

// 保存配储结果进入下一步
export function saveScemeStep(id) {
	return http(`/project/esAnalysisNext/${id}`, {
		method: "GET",
		params: {},
	});
}

// 获取默认电价策略模板
export function getDefaultPriceStrategyTemplate(id) {
	return http(`/project/defaultElecPriceStrategyTemplate/${id}`, {
		method: "GET",
		params: {},
	});
}

// 查询推荐配置
export function getRecommend(id) {
	return http(`/project/analysisDetail/recommend/${id}`, {
		method: "GET",
		params: {},
	});
}

// // 获取固定策略
// export function getPrevData(id) {
// 	return http(`/project/strategyInfo/prev/${id}`, {
// 		method: "GET",
// 		params: {},
// 	});
// }

// // 获取智能策略
// export function getWiseData(id) {
// 	return http(`/project/strategyInfo/wise/${id}`, {
// 		method: "GET",
// 		params: {},
// 	});
// }

// 生成报告
export function saveReport(id) {
	return http(`/project/esAnalysisNext/${id}`, {
		method: "GET",
		params: {},
	});
}

// 查询报告页数据
export function getReportData(shareKey) {
	return http(`/project/share/isValid/${shareKey}`, {
		method: "GET",
		params: {},
	});
}
